import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_PetHealthV1GetsafeDe } from '@flows/insurance/schemas'

const shoulder_height = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('shoulder_height_class')]:
        BaseSchema_PetHealthV1GetsafeDe.shape.shoulder_height_class.unwrap(),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_petHealth:steps.shoulder_height.title',
          values: {
            pet_name: {
              type: 'dynamicValue',
              path: params.helperFunctions.getParamPath('pet_name'),
            },
          },
        },
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        options: [
          {
            value: 'lt_45_cm',
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_petHealth:steps.shoulder_height.lt45',
            },
          },
          {
            value: 'gte_45_cm',
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_petHealth:steps.shoulder_height.gte45',
            },
          },
        ],
        name: params.helperFunctions.getParamPath('shoulder_height_class'),
      },
      {
        type: 'infoBox',
        showInfoIcon: true,
        contentConfiguration: [
          {
            type: 'title',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_petHealth:steps.shoulder_height.infoBox1.title',
            },
            isSmall: true,
          },
          {
            type: 'text',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_petHealth:steps.shoulder_height.infoBox1.text',
            },
          },
        ],
      },
      {
        type: 'infoBox',
        showInfoIcon: true,
        contentConfiguration: [
          {
            type: 'title',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_petHealth:steps.shoulder_height.infoBox2.title',
            },
            isSmall: true,
          },
          {
            type: 'text',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_petHealth:steps.shoulder_height.infoBox2.text',
            },
          },
          {
            type: 'text',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_petHealth:steps.shoulder_height.infoBox2.text2',
            },
          },
        ],
      },
    ],
    subFlow: params.subFlow,
    nextStep: 'pet_age',
  }) as const satisfies AnyStepConfiguration

export default shoulder_height
